(function () {
    "use strict";

    if (!Array.prototype.distint) {

        Array.prototype.distinct = function () {
            var i;
            var len = this.length;
            var out = [];
            var obj = {};

            for (i = 0; i < len; i++) {
                obj[this[i]] = 0;
            }
            for (i in obj) {
                out.push(i);
            }
            return out;
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/Array.distinct.js